import "../SCSS/styles.css";
import { MobileViewCompanyInfoPropsTypes } from "../MobileViewCompanyInfoPropsTypes";
import icons from "../../Assets/Icons/icons";
import images from "../../ImageVariables";
import { EnumSurveyAnswerStatus } from "../../Common/Enums/EnumsTypes";

export default function MobileViewCompanyInfo({
  surveyAnswersInfo,
  handleNextPage,
}: MobileViewCompanyInfoPropsTypes) {
  return (
    <div className="mobile-resp-supplier-view-company-info-cover">
      <div className="mobile-resp-supplier-view-company-info-wrapper">
        <div className="mobile-resp-supplier-view-company-info-inner-wrapper">
          <div className="mobile-view-logo-description-cover">
            <div className="mobile-view-logo-cover">
              <img
                height={"60px"}
                src={
                  surveyAnswersInfo?.companyInfo?.additionalInfo?.companyLogoUrl
                }
                alt="LOGO"
              ></img>
            </div>
            <div className="mobile-view-description-cover">
              {surveyAnswersInfo?.companyInfo?.description}
            </div>
          </div>
          <div className="mobile-view-contact-details-cover">
            <div className="mobile-view-address-cover">
              <div className="loc-icon">{icons.location}</div>
              <div className="mobile-view-address">
                {surveyAnswersInfo?.companyInfo?.address}
              </div>
            </div>
            <div className="mobile-view-contact-cover">
              <div className="mobile-view-contact-cover-inner-cont">
                <span className="mobile-view-phone-icon">{icons.phone}</span>
                <span className="mobile-view-phone-number">
                  {surveyAnswersInfo?.companyInfo?.countryCode && "+"}
                  {surveyAnswersInfo?.companyInfo?.countryCode}{" "}
                  {surveyAnswersInfo?.companyInfo?.phoneNumber}
                </span>
              </div>
              <div className="mobile-view-icon-url-cover">
                <span className="icon">{icons.envelope}</span>
                <span className="url">
                  {surveyAnswersInfo?.companyInfo?.companyUrl}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {surveyAnswersInfo.surveyStatus !== EnumSurveyAnswerStatus.COMPLETED && (
        <div className="supplier-next-btn-cover">
          <div className="contact-next-button">
            <div className="next-button">
              <div className="button" onClick={() => handleNextPage()}>
                <span>Next</span>
                <span className="arrow">
                  <img src={images.whiteArrow} alt="" />
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
